 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"8e65857f15fa868d172afc40513fa56d67d0e867","3":"13f202cf5baf03ae7ea7495ce471df1127d00f32","4":"5fcd5e32","5":"7ffe3c402bbf110ca1ad6adf907c0ed43c140114","6":"e248ee5ad9b570a1019113ca06823c06c1d63b58","7":"56dc042b21eb02c3e41c738da9c3bc8405c4efa4","8":"61a73ce27bf9091f56602bf7b17db2dc0c60fc9d","11":"68c0a17d","13":"component---src-pages-404-js","14":"component---src-pages-amritseries-index-js","15":"component---src-pages-blog-index-js","16":"component---src-pages-contact-examples-js","17":"component---src-pages-contact-file-upload-js","18":"component---src-pages-contact-index-js","19":"component---src-pages-contact-thanks-js","20":"component---src-pages-project-index-js","21":"component---src-pages-tags-index-js","22":"component---src-templates-blog-post-js","23":"component---src-templates-c-4-gt-page-js","24":"component---src-templates-careers-2-page-js","25":"component---src-templates-careers-page-js","26":"component---src-templates-case-study-js","27":"component---src-templates-decluttered-page-js","28":"component---src-templates-decoding-citizen-page-js","29":"component---src-templates-footer-page-js","30":"component---src-templates-frameworks-page-js","31":"component---src-templates-home-legacy-js","32":"component---src-templates-index-page-js","33":"component---src-templates-joinus-page-js","34":"component---src-templates-ksk-js","35":"component---src-templates-media-page-js","36":"component---src-templates-media-post-js","37":"component---src-templates-old-case-study-js","38":"component---src-templates-our-assets-page-js","39":"component---src-templates-our-team-js","40":"component---src-templates-partners-page-js","41":"component---src-templates-product-page-js","42":"component---src-templates-project-domain-post-js","43":"component---src-templates-project-post-js","44":"component---src-templates-sushasan-page-js","45":"component---src-templates-team-page-js","46":"component---src-templates-tgc-page-js"}[chunkId]||chunkId) + "-" + {"0":"ba1e374d1eca0daa30fb","1":"29147cbc04bbc833f6a0","2":"804be43bcb2c235c0b02","3":"16b5e9bfc05c45d056b7","4":"0760523b950de90564ad","5":"88be1f0be8858ab32397","6":"b1be07c4a90cef89da56","7":"b20cb7cabca2cd70fd00","8":"0609f5657d8655cc7d7d","11":"277326d192e650b2122f","13":"74e43fceffd1f1e61a77","14":"574108b751e0eb6e80c3","15":"d258a172214a2f99a4d2","16":"87cf872323d3d1267d07","17":"ab802fb899f7ad9435ea","18":"e17477b8eebf3bfe2707","19":"d25419e43631c669c703","20":"4f643c94cfc8a8a23801","21":"1e02bc3955250d885401","22":"771cb75e2e60dfc23565","23":"47dbe6a674e6c52ab056","24":"ec84c61c8be7140acbe0","25":"6c75f830a7219fe4ae7a","26":"3a1be1ab920cfc4bb51b","27":"18ae46d6afa14c9c96f9","28":"c67374dfb870d8b7a67b","29":"c9ade81c1d122c60b4fb","30":"fb45bc693187a20d5fc4","31":"88dd0d2e55812ab8b404","32":"9b7acff46c2e301375b1","33":"3b80e31fa9e3bec2f445","34":"fb646b1b66aa160c1098","35":"84656bb307c4f1255e62","36":"eb3bf3485b5609c3c827","37":"2dbe2edc4bc97fe1b925","38":"191d6373c579038b903b","39":"5aeff84af139b8d124dd","40":"b35cef044bb2718cf183","41":"4c52d0f345d35a9aa235","42":"894ea2d15e48586b4942","43":"ffcdc8777b363e0e8756","44":"a730b2f60fb30cbcbcd8","45":"96dbf08caa5df039b1bf","46":"25b77a82b36d4e708dc4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"8e65857f15fa868d172afc40513fa56d67d0e867","3":"13f202cf5baf03ae7ea7495ce471df1127d00f32","4":"5fcd5e32","5":"7ffe3c402bbf110ca1ad6adf907c0ed43c140114","6":"e248ee5ad9b570a1019113ca06823c06c1d63b58","7":"56dc042b21eb02c3e41c738da9c3bc8405c4efa4","8":"61a73ce27bf9091f56602bf7b17db2dc0c60fc9d","11":"68c0a17d","13":"component---src-pages-404-js","14":"component---src-pages-amritseries-index-js","15":"component---src-pages-blog-index-js","16":"component---src-pages-contact-examples-js","17":"component---src-pages-contact-file-upload-js","18":"component---src-pages-contact-index-js","19":"component---src-pages-contact-thanks-js","20":"component---src-pages-project-index-js","21":"component---src-pages-tags-index-js","22":"component---src-templates-blog-post-js","23":"component---src-templates-c-4-gt-page-js","24":"component---src-templates-careers-2-page-js","25":"component---src-templates-careers-page-js","26":"component---src-templates-case-study-js","27":"component---src-templates-decluttered-page-js","28":"component---src-templates-decoding-citizen-page-js","29":"component---src-templates-footer-page-js","30":"component---src-templates-frameworks-page-js","31":"component---src-templates-home-legacy-js","32":"component---src-templates-index-page-js","33":"component---src-templates-joinus-page-js","34":"component---src-templates-ksk-js","35":"component---src-templates-media-page-js","36":"component---src-templates-media-post-js","37":"component---src-templates-old-case-study-js","38":"component---src-templates-our-assets-page-js","39":"component---src-templates-our-team-js","40":"component---src-templates-partners-page-js","41":"component---src-templates-product-page-js","42":"component---src-templates-project-domain-post-js","43":"component---src-templates-project-post-js","44":"component---src-templates-sushasan-page-js","45":"component---src-templates-team-page-js","46":"component---src-templates-tgc-page-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"ae7c7d86a46222b6222d","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
